import {Controller} from "@hotwired/stimulus";

// Toggles a class on the element when the window has scrolled past a threshold.
export default class extends Controller {
  static classes = ["scrolled"];
  static values = {
    threshold: {type: Number, default: 0},
    hysteresis: {type: Number, default: 10},
  };

  connect() {
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScroll, {passive: true});
    this.onScroll();
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll);
  }

  onScroll() {
    if (!this.hasScrolledClass) return;

    const shouldBeScrolled = this.computeScrolled();
    this.element.classList.toggle(this.scrolledClass, shouldBeScrolled);
  }

  computeScrolled() {
    const y = window.scrollY;
    const isScrolled = this.element.classList.contains(this.scrolledClass);
    const onThreshold = this.thresholdValue;
    const offThreshold = Math.max(0, this.thresholdValue - this.hysteresisValue);

    if (isScrolled) return y > offThreshold; // stay on until below off
    return y > onThreshold; // turn on when above on
  }
}
